import { Fragment } from 'react';
import { Layouts } from '~/shared';
import { rage } from '~/rage';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { StyledBackground, StyledContainer } from './Background.styled';

const Background: React.FC = () => {
	return (
		<Fragment>
			{rage.config.isStub() && (
				<BgPlaceholder $type={PlaceholderType.VehicleMoveDay} />
			)}
			<StyledContainer className={`${Layouts.Offers}-background`}>
				<StyledBackground />
			</StyledContainer>
		</Fragment>
	);
};

export { Background };
